/* MARCA | 7 Oct 2026 | Cart case milestones. The bar meets each icon at that reward's case count, then fills when the last reward is reached. */
if (!customElements.get('cart-milestones')) {
  class CartMilestones extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      this.onCartChange = (event) => this.refreshFromCart(event);
      document.addEventListener('theme:cart:change', this.onCartChange);
      this.refreshFromCart();
    }

    disconnectedCallback() {
      this.dataset.bound = 'false';
      document.removeEventListener('theme:cart:change', this.onCartChange);
    }

    refreshFromCart(event) {
      const fromEvent = event?.detail?.cartCount;
      const countEl = document.querySelector('[data-cart-count]');
      const fromDom = countEl ? parseInt(countEl.getAttribute('data-cart-count'), 10) : NaN;
      const total = Number.isFinite(fromEvent)
        ? fromEvent
        : Number.isFinite(fromDom)
          ? fromDom
          : parseInt(this.dataset.total, 10) || 0;

      this.dataset.total = String(total);
      this.render(total);
    }

    message(template, goal, remaining) {
      const source = template || '';
      return source
        .split('||goal||')
        .join(String(goal))
        .split('||remaining||')
        .join(String(remaining))
        .split('||amount||')
        .join(String(remaining));
    }

    render(caseCount) {
      const items = [...this.querySelectorAll('[data-milestone]')];
      if (!items.length) return;

      const milestones = items.map((el) => ({
        el,
        threshold: Number(el.dataset.threshold) || 0,
      }));

      const count = milestones.length;
      const max = milestones[count - 1].threshold;
      const positions = milestones.map((_, index) => (index + 0.5) / count);
      let fill = 0;

      if (caseCount >= max) {
        // Last reward reached: fill the whole track, past the final icon.
        fill = 1;
      } else if (caseCount > 0) {
        let previousThreshold = 0;
        let previousPosition = 0;

        for (let index = 0; index < count; index++) {
          const threshold = milestones[index].threshold;
          const position = positions[index];

          if (caseCount < threshold) {
            const span = threshold - previousThreshold;
            const portion = span > 0 ? (caseCount - previousThreshold) / span : 1;
            fill = previousPosition + portion * (position - previousPosition);
            break;
          }

          previousThreshold = threshold;
          previousPosition = position;
        }
      }

      const fillEl = this.querySelector('[data-milestones-fill]');
      if (fillEl) fillEl.style.width = `${Math.max(0, Math.min(fill, 1)) * 100}%`;

      const track = this.querySelector('[data-milestones-track]');
      if (track) {
        track.setAttribute('aria-valuenow', String(Math.max(0, Math.round(caseCount))));
        track.setAttribute('aria-valuemax', String(max));
      }

      const next = milestones.find((milestone) => caseCount < milestone.threshold);
      const reachedTemplate = this.dataset.reachedMessage || '';

      milestones.forEach((milestone) => {
        const reached = caseCount >= milestone.threshold;
        const current = Boolean(next && next.el === milestone.el);
        const remaining = Math.max(0, milestone.threshold - caseCount);
        const status = milestone.el.querySelector('[data-milestone-status]');
        const prefix = milestone.el.querySelector('[data-milestone-prefix]');
        const lockedMessage = milestone.el.dataset.lockedMessage || '';

        milestone.el.classList.toggle('is-reached', reached);
        milestone.el.classList.toggle('is-current', current);

        if (current) milestone.el.setAttribute('aria-current', 'step');
        else milestone.el.removeAttribute('aria-current');

        if (prefix) prefix.hidden = reached || prefix.textContent.trim() === '';

        if (status) {
          // Locked labels stay on their milestone; only swap to the reached message when unlocked.
          if (reached) status.textContent = this.message(reachedTemplate, milestone.threshold, 0);
          else status.textContent = this.message(lockedMessage, milestone.threshold, remaining);
        }
      });
    }
  }

  customElements.define('cart-milestones', CartMilestones);
}
